module.exports = __webpack_public_path__ + "img/CreateWithAI-icon.d6390ccc.svg";